export default (params) => ({
  trigger: {
    name: 'content_blocks.highlighted_product.select_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
          'link',
        ],
      },
      item_id: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: null,
      },
    },
  },
});
